export default [
  {
    path: 'g-fin/despesas',
    name: 'despesas',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Despesas',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Financeiro', link: 'financeiro' },
        { name: 'Saída' }
      ]
    }
  }
]